import { useState } from 'react';
import { BrandLogo } from '@shared/ui/BrandLogo/BrandLogo';
import { useGetAuthProvidersQuery, useStartSignInMutation, type IdentityProvider } from '@entities/account/api/accountApi';
import { apiErrorMessage } from '@shared/api/baseApi';
import { Button } from '@shared/ui/Button';
import styles from './SignInDialog.module.css';

export const RETURN_TO_KEY = 'ys:sign-in-return';
export function SignInOptions({ returnTo }: { returnTo: string }) {
  const { data, isLoading, isError, refetch } = useGetAuthProvidersQuery();
  const [start, { isLoading: starting }] = useStartSignInMutation();
  const [error, setError] = useState<string | null>(null);
  async function signIn(provider: IdentityProvider) {
    setError(null);
    try {
      const result = await start({ provider, intent: 'login' }).unwrap();
      try { sessionStorage.setItem(RETURN_TO_KEY, JSON.stringify({ path: returnTo, at: Date.now() })); } catch { /* Sign-in still works without storage. */ }
      window.location.assign(result.url);
    } catch (cause) { setError(apiErrorMessage(cause)); }
  }
  return <div className={styles.options}>
    {error && <p className={styles.error} role="alert">{error}</p>}
    {(['GOOGLE', 'TELEGRAM'] as const).map(provider => {
      const available = data?.providers.some(entry => entry.provider === provider && entry.available) ?? false;
      return <div key={provider} className={styles.provider}><Button fullWidth variant="secondary" loading={starting} disabled={!available || starting || isLoading} onClick={() => void signIn(provider)}><BrandLogo brand={provider === 'GOOGLE' ? 'google' : 'telegram'} size={24} />Continue with {provider === 'GOOGLE' ? 'Google' : 'Telegram'}</Button>{data && !available && <small>Sign-in setup pending</small>}</div>;
    })}
    {isError && <><p role="alert" className={styles.error}>We could not load sign-in options.</p><Button variant="ghost" onClick={() => void refetch()}>Try again</Button></>}
  </div>;
}
